import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './lib/locales/en/translation.json'
import ru from './lib/locales/ru/translation.json'

const resources = {
  ru: { translation: ru },
  en: { translation: en },
}

export function initI18n() {
  i18n.use(initReactI18next).init({
    resources,
    lng: 'ru',

    interpolation: {
      escapeValue: false,
    },
  })
}

export default i18n
